export default function Testimonials() {
  const testimonials = [
    {
      id: 1,
      name: 'Osman Yavuz',
      position: 'Genel Müdür',
      company: 'Altınova Gıda Tic.',
      sector: 'Gıda Sektörü',
      rating: 5,
      title: 'Yıllar İçinde Değişmeyen Güven',
      text: '2018\'den beri Bioetiket ile çalışıyoruz. Ürün yelpazemiz genişledikçe etiket ihtiyaçlarımız da karmaşıklaştı; onlar her seferinde çözüm buldular. Soğuk zincir yapışkanından kraft tasarıma kadar hiç "hayır" duymadık. Acil siparişlerde bile bizi mahcup etmediler.'
    },
    {
      id: 2,
      name: 'Burcu Şahin',
      position: 'Marka Direktörü',
      company: 'Nokta Cilt Bakım',
      sector: 'Kozmetik',
      rating: 5,
      title: 'Pantone Eşleşmesi Kusursuz',
      text: 'Marka kılavuzumuzdaki turuncu tonunu yıllardır aynı hassasiyette basıyorlar. 12 renk baskı sistemleri sayesinde Pantone 1655 C\'yi rakiplerimizden çok daha iyi yansıtıyoruz. Hologram ve soft-touch kombinasyonunu gören müşteriler kutunun fotoğrafını paylaşmadan edemediler.'
    },
    {
      id: 3,
      name: 'Dr. Kemal Arslan',
      position: 'Kalite Güvence Müdürü',
      company: 'Faros İlaç San.',
      sector: 'Farmasötik',
      rating: 5,
      title: 'GMP Uyumunda Sıfır Hata',
      text: 'Farmasötik tedarik zincirinde hata payı sıfır olmalı. Bioetiket\'in GMP uyumlu üretim prosedürleri ve seri numaralı etiket sistemi, denetimlerimizde bize her zaman güçlü bir referans noktası oluşturdu. Altı yıldır tek bir seri hatası yaşamadık.'
    },
    {
      id: 4,
      name: 'Deniz Kaplan',
      position: 'E-Ticaret Müdürü',
      company: 'Doğal Sepet A.Ş.',
      sector: 'E-Ticaret / Gıda',
      rating: 5,
      title: 'Sezonluk Kampanyaları Uçuşturdular',
      text: 'Bayram, yaz ve hasat dönemlerinde farklı etiket tasarımları bastırıyoruz. Her seferinde 3-4 günde baskı, aynı gün kargo. Tasarım ekipleri fikrimizi anlıyor, ilk provasında doğru renk geliyor. Dijital baskı kalitesi ile bu fiyat, başka yerde bulamazsınız.'
    },
    {
      id: 5,
      name: 'Hüseyin Demirtaş',
      position: 'Üretim Müdürü',
      company: 'MekaTek Sanayi',
      sector: 'Endüstriyel',
      rating: 5,
      title: 'Fabrika Koşullarında 3 Yıl Sonra Hâlâ Okunaklı',
      text: 'Pres makinelerimizin gres ve yağ ortamında dayanıklı etiket arıyorduk. Bioetiket leksan malzeme önerdi, numuneyi fabrikada test ettik; 18 ay sonra bile baskı okunabilir durumdaydı. Şimdi tüm ekipman etiketlerimizi onlardan alıyoruz.'
    },
    {
      id: 6,
      name: 'İpek Uçar',
      position: 'Kurucu',
      company: 'Yaban Gülü Organik',
      sector: 'Butik Gıda',
      rating: 5,
      title: '50 Adette de Tam Profesyonel',
      text: 'Reçelimi pazar tezgahında satarken başladım; şimdi 8 farklı ürünüm var. Bioetiket\'te 50\'şer adetlik siparişleri de büyük fabrikalarla aynı ciddiyetle karşılıyorlar. Kraft tasarım fikirlerime destek oldular, müşterilerim etiketleri sürekli övüyor. Yanımda olduklarını hissediyorum.'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Başlık */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <span className="text-sm font-semibold tracking-widest text-gray-500 uppercase">
              Müşteri Memnuniyeti
            </span>
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
          </div>
          <h2 className="text-5xl font-bold text-[#1A2332] leading-tight mb-2">
            Müşterilerimiz
          </h2>
          <h2 className="text-5xl font-normal text-gray-700 leading-tight mb-6">
            Hakkımızda Ne Diyor?
          </h2>
          <p className="text-base text-gray-600">
            800+ mutlu müşterimizin profesyonel etiket baskı deneyimleri
          </p>
        </div>

        {/* Yorum Kartları */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-8 hover:shadow-lg transition-all duration-300"
            >
              {/* Yıldızlar */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-[#FF6B35]"></i>
                ))}
              </div>

              {/* Başlık */}
              <h3 className="text-lg font-semibold text-[#1A2332] mb-3">
                {testimonial.title}
              </h3>

              {/* Yorum */}
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                &ldquo;{testimonial.text}&rdquo;
              </p>

              {/* Kullanıcı Bilgisi */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#FF6B35]/10 flex-shrink-0">
                  <span className="text-sm font-bold text-[#FF6B35]">
                    {testimonial.name.split(' ').map((n) => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-[#1A2332]">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-gray-500">
                    {testimonial.position}, {testimonial.company}
                  </div>
                  <div className="text-xs text-gray-400 mt-1">
                    {testimonial.sector}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Alt İstatistik */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-4xl font-bold text-[#FF6B35] mb-2">%98</div>
            <div className="text-sm text-gray-600">Müşteri Memnuniyeti</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#FF6B35] mb-2">800+</div>
            <div className="text-sm text-gray-600">Mutlu Müşteri</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#FF6B35] mb-2">%96</div>
            <div className="text-sm text-gray-600">Tekrar Sipariş Oranı</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-[#FF6B35] mb-2">4.9/5</div>
            <div className="text-sm text-gray-600">Ortalama Puan</div>
          </div>
        </div>
      </div>
    </section>
  );
}
